import { fetchMovieByImdbId } from './fetchMovieByImdbId';
import { fetchTVShowByImdbId } from './fetchTVShowByImdbId';
import { fetchStreamingServices } from './fetchStreamingServices';
import { processStreamingServices } from './processStreamingServices';

/**
 * Initializes the TMDb module by fetching movie data using IMDb ID,
 * retrieving available streaming services, and logging them to the console.
 */
export const tmdbModuleInit = async () => {
  const parent = document.querySelector('.header_trailer');
  const imdbId = parent.getAttribute('data-imdb-id');

  if (imdbId) {
    const apiKey = 'd6a10280de27bdc5f3ac515ff34db85f';
    const countryCode = parent.getAttribute('data-region');

    const isTvShow = parent.getAttribute('data-istvshow') === 'true';

    try {
      // Step 1: Fetch the tv or movie data using the IMDb ID
      let data;
      if (isTvShow) data = await fetchTVShowByImdbId(imdbId, apiKey);
      else data = await fetchMovieByImdbId(imdbId, apiKey);

      if (data) {
        const tmdbId = data.id; // e.g. "tt2328900" mary queen of scots

        // Step 2: Fetch the streaming services using the TMDb ID
        const providersData = await fetchStreamingServices(
          tmdbId,
          apiKey,
          isTvShow,
        );
        const streamingServices = processStreamingServices(
          providersData,
          countryCode,
        );

        // Log the streaming services to the console
        // console.log('Streaming services available:', streamingServices);
        // E.g. { name: "Amazon Prime Video", logoPath: "https://image.tmdb.org/t/p/w92/dQeAar5H991VYporEjUspolDarG.jpg" }

        if (streamingServices && streamingServices.length > 0) {
          // Step 3 - Update the DOM with the streaming services info
          const servicesContainer = document.querySelector(
            '.header_trailer-streaming_services-wrapper',
          );
          servicesContainer.innerHTML = '';

          // Create the new h4
          const streamingText = document.createElement('h4');
          streamingText.className =
            'header_trailer-streaming_services-wrapper-text';
          streamingText.textContent = 'Streaming Now:';
          servicesContainer.appendChild(streamingText);

          // Apply streaming provider's logos
          streamingServices.forEach(service => {
            const serviceItem = document.createElement('div');
            serviceItem.classList.add('streaming-service');
            serviceItem.innerHTML = `
              <img src="${service.logoPath}" alt="${service.name}" />            
            `;
            servicesContainer.appendChild(serviceItem);
          });
        }
      }
    } catch (error) {
      console.error(
        'Failed to fetch and log movie data or streaming services:',
        error,
      );
    }
  }
};

// Removed. Lets not call this twice:
//document.addEventListener('DOMContentLoaded', tmdbModuleInit);
